import React from "react";
import Container from "../../components/ui/Container";
import OffsetButton from "../../components/ui/Buttons/OffsetButton";
import auth from "../../services/authServices";
import { ReactComponent as QuranIcon } from "../../assets/telawah-assets/quranIconBtn.svg";
import { useLanguage } from "../../context/LanguageContext";
import { ReactComponent as IslamicPattern } from "../../assets/telawah-assets/patternIslamic.svg";
import { ReactComponent as QuranImg } from "../../assets/telawah-assets/quranCtaImg.svg";

const CtaStudent = () => {
    const token = auth.getToken();
    const { language } = useLanguage();

    const content = {
        description: {
            en: "Join a unique spiritual journey to help you learn the Quran and Islamic teachings in a reliable and simplified way. Reminders lay the foundation for change and success.",
            ar: "كن جزءًا من رحلة إيمانية مميزة تعينك على تعلم القرآن الكريم وتعاليم الإسلام بأسلوب موثوق وميسر، لأن التذكير بالخير أساس التغيير والنجاح.",
        },
        button: {
            en: "Create Your Account",
            ar: "انشئ حسابك الآن",
        },
    };

    return (
        <section
            className={`relative flex flex-col md:flex-row bg-ashGray-50 w-[90%] my-10 mx-auto rounded-xl shadow-lg overflow-hidden py-5 px-5 md:px-10`}
        >
            <IslamicPattern className="absolute hidden md:block top-0 bottom-0 right-5  h-full" />
            <IslamicPattern className="absolute hidden md:block top-0 bottom-0 -left-[60%] w-full h-full" />
            <div className="basis-full flex-center-both relative md:basis-1/2">
                <div className="absolute top-20 hidden md:block bottom-20 left-0 -right-5 bg-ashGray-50" />
                <QuranImg className="ml-0 md:ml-20 max-w-xl px-0 md:px-5 relative" />
            </div>
            <div
                className=""
                style={{
                    backgroundImage: `url(${IslamicPattern})`,
                    backgroundSize: "contain",
                    backgroundPosition: "left left",
                    backgroundRepeat: "no-repeat",
                }}
            ></div>

            <Container
                className={`basis-full mx-3 md:mx-20  justify-center relative md:basis-1/2 z-10 text-center  flex flex-col items-center md:items-start space-y-6`}
            >
                <h2
                    className={`text-2xl text-center ${
                        language === "en" ? "ltr md:text-left" : "md:text-right"
                    } md:text-3xl font-bold text-gray-800`}
                >
                    وَذَكِّرْ فَإِنَّ الذِّكْرَى تَنفَعُ الْمُؤْمِنِينَ
                </h2>

                <p
                    className={`text-gray-600 text-center md:text-right text-md md:text-lg max-w-2xl leading-relaxed`}
                >
                    {content.description[language]}
                </p>

                <OffsetButton
                    color="ashGray"
                    element="Link"
                    ButtonType="Retro"
                    className="scale gap-4 w-fit text-ashGray-50 font-w-bold"
                    to={!token ? "/register" : "/me/user/courses"}
                >
                    <QuranIcon className="w-7 h-full" />
                    <span>{content.button[language]}</span>
                </OffsetButton>
            </Container>
        </section>
    );
};

export default CtaStudent;
